export default __webpack_public_path__ + "static/UNAC2-1940f7b73a5f4b79c81644242f188907.png";